import axios from 'axios';

// PUT /admin/user/:userId — edit identity (firstName, lastName, email). Backend whitelists
// those fields and pre-checks email uniqueness (409). Returns a normalised result so the
// modal can surface a duplicate-email message inline.
export async function putUser(userId, form) {
  try {
    const res = await axios.put(`/admin/user/${userId}`, {
      firstName: form.firstName,
      lastName: form.lastName,
      email: form.email,
    });
    return { ok: res.data && res.data.status === 'SUCCESS' };
  } catch (error) {
    const data = error.response && error.response.data;
    return {
      ok: false,
      status: error.response && error.response.status,
      message: (data && data.status_message) || 'Failed to save user.',
    };
  }
}
